<script lang="ts">
  import Link from "svelte-link";
  import { Card, Col, Image, Row } from "sveltestrap";
  import {learningData} from "../../../Data/Miscellaneous/LearningList"
  import { Learningdetail } from "../../../utils/Constant/Constant";
  import BlogBoxSub from "./BlogBoxSub.svelte";
  let imgPath:string = "/assets/images/faq"

</script>
<Col xl="9" class="xl-60">
    <Row>
        {#each learningData as learningItem}
            <Col xl="12" sm="6">
                <Card>
                    <Row class="blog-box blog-list">
                        <div class="col-xl-5 col-12">
                            <Image fluid class="sm-100-w" src="{imgPath}/{learningItem.img}" alt="" />
                        </div>
                        <Col xl="7" xs="12">
                            <div class="blog-details">
                                <div class="blog-date"><span>{learningItem.date}</span> {learningItem.month}</div>
                                <Link href="/learning/detailedcourse">
                                    <h6>{learningItem.title} </h6>
                                </Link>
                                <div class="blog-bottom-content">
                                    <ul class="blog-social">
                                        <li>{learningItem.name}</li>
                                        <li>{learningItem.likes}</li>
                                    </ul>
                                    <hr>
                                    <p class="mt-0">{Learningdetail}</p>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Card>
            </Col>
        {/each}
        <BlogBoxSub />
    </Row>
</Col>